import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { LayoutDashboard, Package, FileText, Users, Activity, Settings, User, ChevronLeft, ChevronRight, ShieldAlert, IceCreamCone } from 'lucide-react';
export function Sidebar() {
  const [isCollapsed, setIsCollapsed] = useState(false);
  const location = useLocation();
  const toggleSidebar = () => {
    setIsCollapsed(!isCollapsed);
  };
  return <div className={`${isCollapsed ? 'w-20' : 'w-64'} bg-white border-r border-gray-200 h-screen fixed left-0 top-0 transition-all duration-300 ease-in-out z-10`} data-id="element-370">
      {/* Logo */}
      <div className="h-16 border-b border-gray-200 flex items-center px-6" data-id="element-371">
        <div className="flex items-center space-x-3" data-id="element-372">
          <div className="w-8 h-8 bg-purple-50 rounded-lg flex items-center justify-center flex-shrink-0" data-id="element-373">
            <IceCreamCone className="w-5 h-5 text-purple-600" data-id="element-374" />
          </div>
          {!isCollapsed && <span className="text-lg font-semibold text-gray-900" data-id="element-375">Scoop</span>}
        </div>
      </div>
      {/* Navigation */}
      <nav className="px-4 pt-4" data-id="element-376">
        <div className="space-y-1" data-id="element-377">
          <div className={`flex items-center ${isCollapsed ? 'justify-center' : 'space-x-3'} px-3 py-2 text-sm font-medium rounded-lg text-gray-400 cursor-not-allowed`} data-id="element-378">
            <LayoutDashboard className="w-5 h-5" data-id="element-379" />
            {!isCollapsed && <span data-id="element-380">Dashboard</span>}
          </div>
          <div className={`flex items-center ${isCollapsed ? 'justify-center' : 'space-x-3'} px-3 py-2 text-sm font-medium rounded-lg text-gray-400 cursor-not-allowed`} data-id="element-381">
            <Package className="w-5 h-5" data-id="element-382" />
            {!isCollapsed && <span data-id="element-383">Products</span>}
          </div>
          <div className={`flex items-center ${isCollapsed ? 'justify-center' : 'space-x-3'} px-3 py-2 text-sm font-medium rounded-lg text-gray-400 cursor-not-allowed`} data-id="element-384">
            <FileText className="w-5 h-5" data-id="element-385" />
            {!isCollapsed && <span data-id="element-386">Claims</span>}
          </div>
          <div className={`flex items-center ${isCollapsed ? 'justify-center' : 'space-x-3'} px-3 py-2 text-sm font-medium rounded-lg text-gray-400 cursor-not-allowed`} data-id="element-387">
            <Users className="w-5 h-5" data-id="element-388" />
            {!isCollapsed && <span data-id="element-389">Suppliers</span>}
          </div>
          <Link to="/compliance" className={`flex items-center ${isCollapsed ? 'justify-center' : 'space-x-3'} px-3 py-2 text-sm font-medium rounded-lg relative ${location.pathname === '/compliance' ? 'bg-purple-50 text-purple-600' : 'text-gray-600 hover:bg-gray-50'}`} data-id="element-390">
            <ShieldAlert className="w-5 h-5" data-id="element-391" />
            {!isCollapsed && <>
                <span data-id="element-392">Compliance</span>
                <span className="absolute right-2 top-1 bg-red-500 text-white text-xs rounded-full w-5 h-5 flex items-center justify-center" data-id="element-393">
                  3
                </span>
              </>}
            {isCollapsed && <span className="absolute -right-1 -top-1 bg-red-500 text-white text-xs rounded-full w-5 h-5 flex items-center justify-center" data-id="element-394">
                3
              </span>}
          </Link>
          <div className={`flex items-center ${isCollapsed ? 'justify-center' : 'space-x-3'} px-3 py-2 text-sm font-medium rounded-lg text-gray-400 cursor-not-allowed`} data-id="element-395">
            <Activity className="w-5 h-5" data-id="element-396" />
            {!isCollapsed && <span data-id="element-397">Activity</span>}
          </div>
        </div>
        {/* Bottom Section */}
        <div className="absolute bottom-0 left-0 right-0 p-4 border-t" data-id="element-398">
          <div className="space-y-1" data-id="element-399">
            <div className={`flex items-center ${isCollapsed ? 'justify-center' : 'space-x-3'} px-3 py-2 text-sm font-medium rounded-lg text-gray-400 cursor-not-allowed`} data-id="element-400">
              <Settings className="w-5 h-5" data-id="element-401" />
              {!isCollapsed && <span data-id="element-402">Settings</span>}
            </div>
            <div className={`flex items-center ${isCollapsed ? 'justify-center' : 'space-x-3'} px-3 py-2 text-sm font-medium rounded-lg text-gray-400 cursor-not-allowed`} data-id="element-403">
              <User className="w-5 h-5" data-id="element-404" />
              {!isCollapsed && <span data-id="element-405">Profile</span>}
            </div>
          </div>
        </div>
      </nav>
      {/* Toggle Button */}
      <button onClick={toggleSidebar} className="absolute -right-3 top-20 bg-white border rounded-full p-1.5 hover:bg-gray-50" data-id="element-406">
        {isCollapsed ? <ChevronRight className="w-4 h-4 text-gray-600" data-id="element-407" /> : <ChevronLeft className="w-4 h-4 text-gray-600" data-id="element-408" />}
      </button>
    </div>;
}